import AppState, { SCREENS } from '@/js/AppState';
import Button from '@cmp/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Texts from 'react-sdk/Texts';
import classes from './Landing.module.css';
import DataManager from 'react-sdk/haxelibs/DataManager';
import PlayAudio from '@/components/shared/PlayAudio/PlayAudio';
import { FaPlay, FaStop } from 'react-icons/fa6';


const Landing = ({hasSave, playCB}) => {

  let text = null
  let audio = null
  let volume = 1
  let volumeTexts = Texts.get("landing-descr-dial-volume")
  if (volumeTexts) {
    volume = parseFloat(volumeTexts)
    if (isNaN(volume))
      volume = 1
  }
  
  let introDial = DataManager.getFile("data/dials.data")?.getLine(Texts.get("landing-descr-dial-id"))
  if (introDial != null) {
    text = introDial.get("Text")
    audio = introDial.get("Audio")
  } else
    text = Texts.get("landing-title")

  return (
  <div className={classes.Landing}>
    {audio &&
    
      <PlayAudio audio={audio} autoplay={true} volume={volume}>
        {(playing, handleClick) => {
          return (
          <Button
          icon={playing ? <FaStop/> : <FaPlay />}
          onClick={handleClick} className={classes.playAudioBtn} />)
        }}
      </PlayAudio>
    }
    <h1 className={classes.title} dangerouslySetInnerHTML={{__html: Texts.get("landing-title")}} />


    <div
    className={classes.descr}
    dangerouslySetInnerHTML={{__html: text }}/>

    <div className={classes.play_btn}>
      <Button onClick={playCB} name="playButton">
        {Texts.get("landing-btn-play")}
      </Button>
    </div>
  </div>
  );
};

export default  observer(Landing)
